import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'helpers/GlobalHelper';
import Overlay from 'components/Overlay';

const NotEntitled = ({
  backgroundUrl,
  isActive,
  notEntitledChildren,
  notEntitledTheme,
  backgroundClass,
  children,
  onCloseClick,
  sharedTheme,
}) => {
  if (!isActive) return null;
  return (
    <Overlay
      backgroundClass={backgroundClass}
      backgroundUrl={backgroundUrl}
      theme={notEntitledTheme}
      sharedTheme={sharedTheme}
      rendered={isActive}
      innerContainerChildren={notEntitledChildren}
      innerContainerChildrenParams={{ onCloseClick }}
    >
      {children}
    </Overlay>
  );
};

NotEntitled.defaultProps = {
  backgroundUrl: null,
  isActive: false,
  notEntitledChildren: noop,
  notEntitledTheme: {},
  backgroundClass: null,
  children: null,
  onCloseClick: noop,
  sharedTheme: {},
};

NotEntitled.propTypes = {
  backgroundUrl: PropTypes.string,
  isActive: PropTypes.bool,
  notEntitledChildren: PropTypes.func,
  notEntitledTheme: PropTypes.shape({}),
  backgroundClass: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onCloseClick: PropTypes.func,
  sharedTheme: PropTypes.shape({}),
};

export default NotEntitled;
